import React from 'react';
import { Link } from 'react-router-dom';
import {
  Phone,
  FileText,
  BarChart3,
  Users
} from 'lucide-react';
import QAFloatingButton from '../components/QAFloatingButton';

const Dashboard = () => {
  const dashboardCards = [
    {
      title: 'Call Management',
      description: 'Initiate new calls via Knowlarity API',
      icon: Phone,
      path: '/call-management',
      color: '#3b82f6',
    },
    {
      title: 'Active Connections',
      description: 'Monitor WebSocket connections',
      icon: Users,
      path: '/connections',
      color: '#10b981',
    },
    {
      title: 'Transcriptions',
      description: 'Manage audio transcription jobs',
      icon: FileText,
      path: '/transcriptions',
      color: '#8b5cf6',
    },
    {
      title: 'AI Summarization',
      description: 'Generate AI summaries from transcripts',
      icon: BarChart3,
      path: '/summarizations',
      color: '#f59e0b',
    },
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
      <div className="container" style={{ paddingTop: '32px', paddingBottom: '32px' }}>
        {/* Header */}
        <div className="dashboard-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h1 className="dashboard-title">Dashboard</h1>
            <p className="dashboard-subtitle">Audio Streaming Service</p>
          </div>
        </div>

        {/* Quick Actions */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{ fontSize: '24px', fontWeight: '600', color: '#1e293b', marginBottom: '24px' }}>
            Quick Actions
          </h2>
          <div className="grid grid-cols-2" style={{ gap: '24px' }}>
            {dashboardCards.map((card) => {
              const IconComponent = card.icon;
              return (
                <Link
                  key={card.path}
                  to={card.path}
                  className="action-card"
                >
                  <div className="action-card-header">
                    <div
                      className="action-card-icon"
                      style={{ background: card.color }}
                    >
                      <IconComponent style={{ width: '24px', height: '24px' }} />
                    </div>
                    <h3 className="action-card-title">{card.title}</h3>
                  </div>
                  <p className="action-card-description">{card.description}</p>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
      
      {/* Q&A Floating Button */}
      <QAFloatingButton />
    </div>
  );
};

export default Dashboard;